import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";

let clientId = "";
let redirectUri = "";
const authority = "https://login.microsoftonline.com/9120276d-6bfd-47fe-a09f-cdcf486f545f"

if (window.location.origin.includes("vending-mnt.c1nacloud.com") || window.location.origin.includes("ase-m-vdp-001")) {
  clientId = "317338cc-c932-4973-ab3f-07d8fad6b505";
  redirectUri = "https://vending-mnt.c1nacloud.com/login";
} else if (window.location.origin.includes("vending-dev.c1nacloud.com") || window.location.origin.includes("ase-d-vdp-001")) {
  clientId = "317338cc-c932-4973-ab3f-07d8fad6b505";
  redirectUri = "https://vending-dev.c1nacloud.com/login";
} else if (window.location.origin.includes("performance")) {
  clientId = "0cc8a8d7-c821-4080-9423-ae474ff89aca";
  redirectUri = "https://as-performance-linux-vendprime.azurewebsites.net/login";
} else if (window.location.origin.includes("ase-q-vdp-001-stage.azurewebsites.net")) {
  clientId = "0cc8a8d7-c821-4080-9423-ae474ff89aca";
  redirectUri = "https://ase-q-vdp-001-stage.azurewebsites.net/login";
} else if (window.location.origin.includes("vending-qa.c1nacloud.com") || window.location.origin.includes("ase-q-vdp-001.azurewebsites.net")) {
  clientId = "0cc8a8d7-c821-4080-9423-ae474ff89aca";
  redirectUri = "https://vending-qa.c1nacloud.com/login";
} else if (window.location.origin.includes("ase-l-vdp-001-stage.azurewebsites.net")) {
  clientId = "0cc8a8d7-c821-4080-9423-ae474ff89aca";
  redirectUri = "https://ase-l-vdp-001-stage.azurewebsites.net/login";
} else if (window.location.origin.includes("vending-prf.c1nacloud.com") || window.location.origin.includes("ase-l-vdp-001.azurewebsites.net")) {
   clientId = "0cc8a8d7-c821-4080-9423-ae474ff89aca";
  redirectUri = "https://vending-prf.c1nacloud.com/login";
}  else if (window.location.origin.includes("production")) {
  clientId = "2e1615c0-a403-4778-9cc0-5e7661ffb453";
  redirectUri = "https://as-production-linux-vendprime.azurewebsites.net/login";
} else if (window.location.origin.includes("ase-p-vdp-001-stage.azurewebsites.net")) {
  clientId = "2e1615c0-a403-4778-9cc0-5e7661ffb453";
  redirectUri = "https://ase-p-vdp-001-stage.azurewebsites.net/login";
} else if (window.location.origin.includes("vending.c1nacloud.com") || window.location.origin.includes("ase-p-vdp-001.azurewebsites.net")) {
  clientId = "2e1615c0-a403-4778-9cc0-5e7661ffb453";
  redirectUri = "https://vending.c1nacloud.com/login";
}

export const msalConfig = {
  auth: {
    clientId,
    authority,
    redirectUri,
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
 scopes: ["User.Read"]
};

export const msalInstance = new PublicClientApplication(msalConfig);